import React, { memo } from 'react';
import { Container, Image, Titulo, Line1, LogoContainer } from './bannerriograndestyles'; // Asegúrate de importar 'LogoContainer' si decides agregarlo
import fondo from './banner palomares.jpg';
import logo from './logopalomares.png';

const BannerAcademy = () => {
  return (
    <Container>
      <Image src={fondo} alt="imagen fondo" />
      <Titulo>
        <Line1>Palomares padel club</Line1>
        <LogoContainer>
          <img src={logo} alt="Logo" style={{  height: '120px', margin: '20px' }} />
        </LogoContainer>
      </Titulo>
    </Container>
  );
};

export default memo(BannerAcademy);